import React from "react"
import AudioPlayer from "react-h5-audio-player"
import { graphql } from "gatsby"
import { Heading, Box } from "@chakra-ui/react"
import Layout from "../components/Layout"
import AvailablePlatforms from "../components/AvailablePlatforms"
import "react-h5-audio-player/lib/styles.css"

const SITE_URL = "https://podcast.overbuild.top"
const X_URL = "https://x.com/overbuild_top"
const INSTAGRAM_URL = "https://www.instagram.com/overbuild_top/"

const replaceLegacyReferences = content =>
  content
    .replace(
      /https?:\/\/podcast\.overbuild\.io\/podcasts\/(\d+)\/?/gi,
      `${SITE_URL}/ep/$1/`
    )
    .replace(/https?:\/\/podcast\.overbuild\.io/gi, SITE_URL)
    .replace(
      /https?:\/\/(?:www\.)?(?:twitter\.com|x\.com)\/@?overbuild_io\/?/gi,
      X_URL
    )
    .replace(
      /https?:\/\/(?:www\.)?instagram\.com\/@?overbuild_io\/?/gi,
      INSTAGRAM_URL
    )
    .replace(/overbuild_io\b/gi, "overbuild_top")

const preprocessContent = content => {
  let res = replaceLegacyReferences(content)
  // add urls
  res = res.replace(/\((https?:\/\/)([^)]+)\)/gi, (match, p1, p2) => {
    const url = `${p1}${p2}`
    return `<a href="${url}" target="_blank">(${url})</a>`
  })
  // add X
  res = res.replace(
    /(?:twitter|x): @overbuild_top/gi,
    `<a href="${X_URL}">X: @overbuild_top</a>`
  )
  // add ig
  res = res.replace(
    /i(?:nsta)?g(?:ram)?: @overbuild_top/gi,
    `<a href="${INSTAGRAM_URL}">Instagram: @overbuild_top</a>`
  )
  // add mailto
  res = res.replace(
    /contact\.overbuild@gmail\.com/i,
    `<a href="mailto:contact.overbuild@gmail.com" target="_blank">contact.overbuild@gmail.com</a>`
  )
  return res
}

export default ({ data }) => {
  const item = data.allSitePage.edges[0].node.context
  const createMarkup = () => ({ __html: preprocessContent(item.content) })
  return (
    <Layout>
      <Heading as="h1" size="lg">
        {item.title}
      </Heading>
      <Box paddingTop={5} paddingBottom={5}>
        <AudioPlayer src={item.enclosure.url} />
      </Box>
      <Box
        p={1}
        dangerouslySetInnerHTML={createMarkup()}
        sx={{
          a: {
            color: "teal",
          },
        }}
      />
      <AvailablePlatforms />
    </Layout>
  )
}

export const query = graphql`
  query($path: String!) {
    allSitePage(filter: { path: { eq: $path } }) {
      edges {
        node {
          context {
            id
            title
            content
            enclosure {
              url
            }
            itunes {
              summary
            }
          }
        }
      }
    }
  }
`
